/**
 * Application Entry Point
 * Initializes React application with strict mode and error boundaries
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
import './styles/index.css';

// Create root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render application with error boundary wrapper
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
